// removed by extract-text-webpack-plugin
module.exports = {"root":"selected-products--root--1ftyNNCo credit-history--root--2FQeiMhy","header":"selected-products--header--2QzqW0cn credit-history--header--1QYa_OOl","body":"selected-products--body--JEne4DyI credit-history--body--2BwHZg00","mobile-only":"selected-products--mobile-only--3HY_H24s credit-history--mobile-only--1QQ3wi2h","mobileOnly":"selected-products--mobile-only--3HY_H24s credit-history--mobile-only--1QQ3wi2h","delete":"selected-products--delete--1wGKo-7l"};


//////////////////
// WEBPACK FOOTER
// ./components/product-picker/selected-products/styles.css
// module id = ./components/product-picker/selected-products/styles.css
// module chunks = 0